export enum Role {
  Admin = 'Administrador',
  Client = 'Client',
  User = 'User',
  PlatformAdmin = 'Administrador de plataforma',
  Operator = 'Operador',
  Supervisor = 'Supervisor'
}
